<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="cssClass"
    :width="width"
    :height="height"
    :fill="color"
    viewBox="0 -960 960 960"
  >
    <path
      d="M109-120q-11 0-20-5.5T75-140q-5-9-5.5-19.5T75-180l370-640q6-10 15.5-15t19.5-5q10 0 19.5 5t15.5 15l370 640q6 10 5.5 20.5T885-140q-5 9-14 14.5t-20 5.5H109Zm69-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm0-120q17 0 28.5-11.5T520-400v-120q0-17-11.5-28.5T480-560q-17 0-28.5 11.5T440-520v120q0 17 11.5 28.5T480-360Zm0-100Z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    cssClass: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '40',
    },
    height: {
      type: String,
      default: '24',
    },
    color: {
      type: String,
      default: '#f37053',
    },
  },
}
</script>
